import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { SalonFormattedAddressPipe } from '@app/shared/pipes/salon-formatted-address.pipe';
import { ISalonAddressData } from '@app/shared/models';

export const getSalonLogoUrlOrDefault = (salonlogoUrl: string): string => salonlogoUrl ? salonlogoUrl : '/assets/img/default-salon-logo.png';
export const getSalonPictureUrlOrDefault = (photoUrl: string): string => photoUrl ? photoUrl : '/assets/img/image-placeholder.svg';
export const getSalonRoute = (salonDetails: ISalonDetailsApi): Array<string> => ['/salon', salonDetails.city, salonDetails.alias];

export const extendSalonImagesWithDefaults =
  (salonDetails: ISalonDetailsApi): ISalonDetailsApi => {
    return {
      ...salonDetails,
      logoUrl: getSalonLogoUrlOrDefault(salonDetails.logoUrl),
      photoUrl: getSalonPictureUrlOrDefault(salonDetails.photoUrl)
    };
  };

export const getGoogleMapsUrlFromSalonAdress = (salonAddress: ISalonAddressData): string => {
  const formattedAddress = new SalonFormattedAddressPipe().transform(salonAddress);
  const apiUrl = 'https://www.google.com/maps?q=';
  const encodedAddress = encodeURIComponent(formattedAddress);
  return apiUrl + encodedAddress;
};
